<template>
    <nav aria-label="Breadcrumb">
        <ol class="flex items-center h-full">
            <slot />
        </ol>
    </nav>
</template>
